import { render, staticRenderFns } from "./AccessTokenModal.vue?vue&type=template&id=bcc03a0c&"
import script from "./AccessTokenModal.vue?vue&type=script&lang=ts&"
export * from "./AccessTokenModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports